import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { reducer } from './reducer';
import { changeScale, toggleOptional } from './actions';
import { MapScalePreview } from './preview';
import { MapScaleForm } from './form';
import { formatScale } from './utils';
import { makeGetItems } from './selectors';
import { withSettings } from '../withSettings';
const makeMapStateToProps = () => {
    const getItems = makeGetItems();
    return (state, props) => {
        return {
            ...state[props.componentIdent],
            value: state[props.componentIdent].scale,
            items: getItems(state, props.componentIdent),
            isChecked: !state[props.componentIdent].isHidden,
            text: formatScale(state['map']?.scale || 0),
            mapMinMaxScale: state['map']?.minMaxScale,
        };
    };
};
const mapDispatchToProps = (dispatch, props) => {
    return {
        onChange: (value) => {
            dispatch(changeScale(value, props.componentIdent));
        },
        onSwitchChange: props.isOptional
            ? (e) => {
                dispatch(toggleOptional(e.target.checked, props.componentIdent));
            }
            : undefined,
    };
};
export const MapScalePreviewContainer = compose(withReducer(reducer), connect(makeMapStateToProps, null))(MapScalePreview);
export const MapScaleFormContainer = compose(withReducer(reducer), connect(makeMapStateToProps, mapDispatchToProps))(withSettings(MapScaleForm));
//# sourceMappingURL=container.js.map